'use client'

/**
 * Carte des projets de la page publique — seul morceau client de la page.
 * `CompanyProjectsMap` charge Leaflet depuis le navigateur : il reste en
 * import dynamique sans rendu serveur (ssr: false), comme sur la fiche
 * entreprise historique, pour que la page reste légère sur mobile.
 */
import dynamic from 'next/dynamic'
import { useState } from 'react'
import type { PointCarte } from '@/lib/entreprises/contenu-page-publique'

const CompanyProjectsMap = dynamic(() => import('@/components/CompanyProjectsMap'), {
  ssr: false,
  loading: () => <div className="h-[340px] w-full rounded-2xl bg-sage/60 animate-pulse" aria-hidden />,
})

export default function CartePublique({ points, couleur, hauteur }: { points: PointCarte[]; couleur: string; hauteur?: string }) {
  const [actif, setActif] = useState<string | null>(null)
  if (points.length === 0) return null
  return (
    <CompanyProjectsMap
      projects={points}
      activeSlug={actif}
      onPinClick={setActif}
      primaryColor={couleur}
      height={hauteur}
    />
  )
}
